import React, {useState,useEffect,Fragment,lazy,Suspense} from 'react';
import { imageSet } from '../helper/Images';
import { FormattedMessage } from 'react-intl';
import content from 'Content/content.json';
import QuizBanner from './banner/quizBanner';
import PromoBanner from './banner/promoBanner';
import VirtualMirrorBanner from './banner/virtualMirrorBanner';
const CenterNavigation = lazy(() => import('./centernavigation'));
const RightBackgroundSection = lazy(() => import('./background/rightSection'));
const LeftBackgroundSection = lazy(() => import('./background/leftSection'));
import Appsflyer from 'Components/helper/Appsflyer';
import { LANG_JP, language, showQuiz, showPromo, pageDefaultTitle, LANG_RU, LANG_ARABIA, LANG_ARABIA_EN } from 'Root/constants';
import './home.scss';
import { LANG_AZ } from '../../constants';

const imgs = { 
  promo_banner: imageSet[content['data']['homepage_cards'][language]['promo_card']],
  beauty_advisor_btn: imageSet[content['data']['homepage_cards'][language]['quiz_card']],
  vm_btn_img: imageSet[content['data']['homepage_cards'][language]['model_card']]
}

const initialState = {
  showCamPopUp: false,
  cookieSlideUp: false
};

const Home = (props) => {
  const [stateObj, setStateObj] = useState(initialState);
  useEffect(() => {
    setStateObj(prevState => ({
      ...prevState,
      cookieSlideUp: true
    }));
  }, []);

  const {
    data: {
      homepage_cards: {
        [language]: { promo_card, quiz_card, model_card },
      },
    },
  } = content;

  useEffect(() => {
    document.body.classList.add("home");
    return () => {
      document.body.classList.remove("home");
    };
  });

  useEffect(() => {
    if(language === LANG_JP) {
      document.title = pageDefaultTitle + "|home";
      return () => {
        document.title = pageDefaultTitle;
      }
    }
  });


  useEffect(() => {
    setStateObj(prevState => ({
      ...prevState,
      cookieSlideUp: true
    }));
  }, []);

  const showCamPopUp = () => {
    setStateObj(prevState => ({
      ...prevState,
      showCamPopUp: true
    }));
    document.body.classList.add('open');
  }

  const redirectTo = path => {
    props.history.push({
      pathname: path,
      search: props.location.search
    });
  }

  const hideCamPopUp = () => {
    setStateObj(prevState => ({
      ...prevState,
      showCamPopUp: false
    }));
    document.body.classList.remove('open');
  }

  if (language !== LANG_AZ) {
    return (
      <Fragment>
        {/* <Appsflyer/> */}
        {language !== LANG_JP && (
          <section className="content--component__home">
            <Suspense fallback={<div></div>}>
              <LeftBackgroundSection />
              <CenterNavigation />
              <RightBackgroundSection />
            </Suspense>
          </section>
        )}
        {language === LANG_JP && (
          <section className="content--component__home">
            <aside className="content--component__home-left">
              <VirtualMirrorBanner
                image={imageSet[model_card]}
                language={language}
              />
            </aside>
            <aside
              className={
                showPromo && showQuiz
                  ? 'content--component__home-right multiple'
                  : 'content--component__home-right'
              }
            >
              {showQuiz && (
                <QuizBanner image={imageSet[quiz_card]} language={language} />
              )}
              {showPromo && (
                <PromoBanner image={imageSet[promo_card]} language={language} />
              )}
            </aside>
          </section>
        )}
      </Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
      <div className="home-component">
        <div className="component-wrapper">
          <div className="cards">
            <div className="card-item card-item--left">
              <div className="card card--vm">
                <div className="card-body">
                  <VirtualMirrorBanner
                    image={imageSet[model_card]}
                    language={language}
                  />
                  <div className="card-title">
                    { language === 'hk' ?
                      (<FormattedMessage id="home.lens_find" defaultMessage="Find the Best Lens for me." />)
                      : (<FormattedMessage id="home.lens_find" defaultMessage="Find the Best Lens for me." />)
                    }
                  </div>
                  <div className="card-subtitle text-small">
                    <FormattedMessage id="home.lens_continue" defaultMessage="Find the Best Lens for me." />
                  </div>
                </div>
              </div>
            </div>
            <div className={ showPromo === 'yes' && showQuiz === 'yes' ? 'card-item card-item--right card-item--multiple' : 'card-item card-item--right'}>
                <div className="card card--quiz" onClick={() =>redirectTo('quiz')}>
                  <div className="card-body">
                    <img className="img-responsive card-image" src={imgs.beauty_advisor_btn} alt=""/>
                  </div>
                </div>

              { (showPromo === 'yes') &&
                <div className="card card--promo">
                  <div className="card-body">
                    { language !== 'th' && process.env.REACT_APP_PROMO_LINK ?
                        <a href={process.env.REACT_APP_PROMO_LINK} target="_blank">
                          <img
                            alt=""
                            className="img-responsive card-image"
                            src={imgs.promo_banner}
                          />
                        </a>
                      : language !== 'th' ?
                        <img
                          alt=""
                          className="img-responsive card-image"
                          src={imgs.promo_banner}
                        />
                      :
                      null
                    }

                    { language === 'th' && process.env.REACT_APP_PROMO_LINK ?
                        <a href={process.env.REACT_APP_PROMO_LINK} target="_blank">
                          <img
                            alt=""
                            className="img-responsive card-image hidden-small"
                            src={imgs.promo_banner}
                          />
                          <img
                            alt=""
                            className="img-responsive card-image hidden-large"
                            src={imageSet[content['data']['homepage_cards']['th']['promo_card_small']]}
                          />
                        </a>
                      : language === 'th' ?
                        <>
                          <img
                            alt=""
                            className="img-responsive card-image hidden-small"
                            src={imgs.promo_banner}
                          />
                          <img
                            alt=""
                            className="img-responsive card-image hidden-large"
                            src={imageSet[content['data']['homepage_cards']['th']['promo_card_small']]}
                          />
                        </>
                      : null
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      { stateObj.showCamPopUp ?
        <AllowCamera closeSelf={hideCamPopUp} search={props.location.search} />
        :
        null
      }
    </React.Fragment>
    );
  }
};

export default Home;
